/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper from "swiper";
import { Navigation, Autoplay } from "swiper/modules";
Swiper.use([Navigation, Autoplay]);
import { customCursor } from "./../partials/customCursor.js";

export function slider() {
    const artistsSliderSelector = ".artists-slider__slider-wrap.swiper";
    const latestArticlesSliderSelector = ".latest-articles__items-wrap.swiper";
    const imageGalleryTopRowSelector = ".image-gallery__row--top.swiper";
    const imageGalleryBottomRowSelector = ".image-gallery__row--bottom.swiper";
    //Fix the tabindex for accebility if the content of the slide is wrapped in an anchor tag
    const handleSlideChangeTransitionEnd = function (swiper) {
        swiper.el
            .querySelectorAll(" .swiper-slide > a")
            .forEach((slide) => {
                slide.setAttribute("tabindex", "-1");
            });

        const activeSlide = swiper.el.querySelector(" .swiper-slide-active > a"
        );
        if (activeSlide != null) {
            activeSlide.setAttribute("tabindex", "0");
        }
    };

    //Makes sure that the lazyloaded image on the duplicate slide has the right class so it doesnt show up as grey
    const handleSlideChange = function () {
        var nextDuplicateSlide = document.querySelector(".swiper-slide-duplicate.swiper-slide-next");
        if (nextDuplicateSlide != null) {
            var unloadedSlideImage = nextDuplicateSlide.querySelector("img.lazyloading");
            if (unloadedSlideImage != null) {
                unloadedSlideImage.classList.replace("lazyloading", "lazyloaded");
            }
        }
    }

    const init = function () {

        //Artists sliders
        const artistsSliders = [];
        const artistsSliderElements = document.querySelectorAll(artistsSliderSelector);
        if (artistsSliderElements) {
            artistsSliderElements.forEach(slider => {

                artistsSliders.push(new Swiper(slider, {
                    speed: 500,
                    slidesPerView: "auto",
                    watchOverflow: true,
                    loop: true,
                    spaceBetween: 15,
                    slidesOffsetBefore: 0,
                    breakpoints: {
                        769: {
                            spaceBetween: 35,
                            slidesOffsetBefore: 0,

                        },
                        1170: {
                            spaceBetween: 35,
                            slidesOffsetBefore: 30
                        }
                    },
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .slider-navigation__next",
                        prevEl: '#' + slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    on: {
                        init: (swiper) => {
                            swiper.slidePrev(0);
                            swiper.slidePrev(0);
                            swiper.slideNext(0);
                            swiper.slideNext(0);
                            customCursor('.artist-card');
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        //Latest Articles sliders
        const latestArticlesSliders = [];
        const latestArticlesSliderElements = document.querySelectorAll(latestArticlesSliderSelector);
        if (latestArticlesSliderElements) {
            latestArticlesSliderElements.forEach(slider => {

                latestArticlesSliders.push(new Swiper(slider, {
                    speed: 500,
                    slidesPerView: "auto",
                    watchOverflow:true,
                    observer:true,
                    observeParents:true,
                    spaceBetween: 15,
                    breakpoints: {
                        992: {
                            spaceBetween: 30
                        }
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                }));
            })
        }

        //Image Gallery Top Row sliders
        const imageGallerySlidersSpeed = 9000;
        const imageGalleryTopRowSliders = [];
        const imageGalleryTopRowSliderElements = document.querySelectorAll(imageGalleryTopRowSelector);
        if (imageGalleryTopRowSliderElements) {
            imageGalleryTopRowSliderElements.forEach(slider => {

                imageGalleryTopRowSliders.push(new Swiper(slider, {
                    speed: imageGallerySlidersSpeed,
                    autoplay: {
                        delay: 0
                    },
                    allowTouchMove: false,
                    slidesPerView: "auto",
                    watchOverflow: true,
                    loop: true,
                    spaceBetween: 8,
                    breakpoints:{
                        769: {
                            spaceBetween: 15
                        },
                    },
                    on:{
                        init: (swiper) => {
                            swiper.slidePrev(0);
                            swiper.slideNext(0);
                        },
                    }
                }));
            })
        }

        //Image Gallery Bottom Row sliders
        const imageGalleryBottomRowSliders = [];
        const imageGalleryBottomRowSliderElements = document.querySelectorAll(imageGalleryBottomRowSelector);
        if (imageGalleryBottomRowSliderElements) {
            imageGalleryBottomRowSliderElements.forEach(slider => {

                imageGalleryBottomRowSliders.push(new Swiper(slider, {
                    speed: imageGallerySlidersSpeed,
                    autoplay: {
                        delay: 0,
                        reverseDirection: true
                    },
                    allowTouchMove: false,
                    slidesPerView: "auto",
                    watchOverflow: true,
                    loop: true,
                    spaceBetween: 8,
                    breakpoints:{
                        769: {
                            spaceBetween: 15
                        },
                    },
                    on:{
                        init: (swiper) => {
                            swiper.slidePrev(0);
                            swiper.slideNext(0);
                        },
                    }
                }));
            })
        }
    };

    init();
}
